// extracted by mini-css-extract-plugin
export default {"formStyle":"ContactForm_formStyle__8EvUH","formArea":"ContactForm_formArea__10vEL"};